import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCompanyStore = defineStore('company', () => {
  const currentCompany = ref(localStorage.getItem('selectedCompany'));
  
  const setCompany = (companyId) => {
    currentCompany.value = companyId;
    localStorage.setItem('selectedCompany', companyId);
  };

  const clearCompany = () => {
    currentCompany.value = null;
    localStorage.removeItem('selectedCompany');
  };

  return { currentCompany, setCompany, clearCompany };
});